<template>
  <v-container fluid>
    <v-row>
      <v-col class="ml-3">
        <v-card class="pa-4">
          <v-row>
            <v-col class="pl-4">
              Set <span class="font-weight-medium">visible</span> to allow employees under the departments to view Leave Dashboard By employee's department.
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="settings"
            :loading="loading"
            disable-pagination
            hide-default-footer
            class="elevation-5"
          >
            <template v-slot:item.is_visible="{ item }">
              <v-icon medium>
                {{ item.is_visible ? 'mdi mdi-check-circle text-success': 'mdi mdi-close-circle text-danger' }}
              </v-icon>
            </template>

            <template v-slot:item.action="{ item }">
              <setup-leaves-department-leave-dashboard-dialog-edit
                v-if="$hasPermissionTo(['update leave dashboard by departments'])"
                :setting="item"
                @updated="loadSettings"
              />
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupLeavesDepartmentLeaveDashboardDialogEdit: () => import('@/components/hris/setup/leaves/department-leave-dashboard/DialogEdit'),
    },

    metaInfo () {
      return {
        title: 'Leave Dashboard By Department Settings',
      }
    },

    data () {
      return {
        loading: false,
        settings: [],
        headers: [
          {
            text: 'Departments', 
            sortable: false, 
            value: 'name',
          },
          {
            text: 'Is Visible?',
            sortable: false,
            align: 'center',
            value: 'is_visible',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
      }
    },
    
    created () {
      this.loadSettings()
    },
    methods: {
      loadSettings () {
        this.loading = true
        this.$api.departmentLeaveDashboards().list()
          .then(res => {
            this.settings = res.data

            this.loading = false
          })
      },
    },
  }
</script>
